import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Button, Icon, Tooltip } from '@mui/material'
import { RootState } from '../../reducers'
import { useStyles } from '../CaseWorklist/Pathologist/inboxStyles'
import { HolidayColumns } from '../CaseWorklist/ITAdmin/tableColumnHeaders'
import AddIcon from '@mui/icons-material/Add'
import EditHolidayDialog from './EditHolidayDialog'
import AddHolidayDialog from './AddHolidayDialog'
import DeleteDialog from '../HOC/DeleteDialog'
import SuccessSnackBar from '../HOC/SuccesSnackBar'
import ErrorSnackBar from '../HOC/ErrorSnackBar'
import { DeleteHolidayDataSettings, getHolidayData } from '../../actions/api/fetchCalendarData'
import { DataGrid } from '@mui/x-data-grid'

export default function HolidayTable() {
  const classes = useStyles()
  const holidayData = useSelector((state: RootState) => state.addHolidayData)
  const { delete_holiday_success, delete_holiday_error } = useSelector(
    (state: RootState) => state.deleteHolidayResponse,
  )
  const [addOpen, setAddOpen] = useState(false)
  const [editOpen, setEditOpen] = useState(false)
  const [deleteHolidayOpen, setDeleteHolidayOpen] = useState(false)
  const [paramsInfo, setParamsInfo] = useState({ id: 0 })
  const [infoPassed, setInfoPassed] = useState(false)
  const [addHoliday, setAddHoliday] = useState(false)
  const [editHoliday, setEditHoliday] = useState(false)
  const [pathologistUserId, setPathologistUserId] = useState(null)
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [deleteProcedureCodeOpen, setDeleteProcedureCodeOpen] = useState(false)
  const dispatch = useDispatch()

  const handleAddHolidays = (params) => {
    setParamsInfo(params)
    setAddHoliday(true)
    setAddOpen(true)
    setInfoPassed(true)
  }
  const handleEditHolidays = (params) => {
    setParamsInfo(params)
    setEditHoliday(true)
    setEditOpen(true)
    setInfoPassed(true)
  }
  const handleDeleteHolidays = (params) => {
    setParamsInfo(params)
    setDeleteHolidayOpen(true)
  }
  const handleDeleteHolidayClose = () => setDeleteHolidayOpen(false)
  const openSnackBar = async () => {
    await setOpenSuccessSnackBar(true)
  }
  const HolidayIconRender = {
    field: '',
    headerName: 'Actions',
    disableColumnMenu: true,
    width: 405,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    renderCell: (params) => {
      return (
        <div>
          <Tooltip title="Edit Holiday" placement="top-start">
            <Icon onClick={() => handleEditHolidays(params.row)}>edit_outlined</Icon>
          </Tooltip>
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Delete Holiday" placement="top-start">
            <Icon onClick={() => handleDeleteHolidays(params.row)}>delete_outlined</Icon>
          </Tooltip>
        </div>
      )
    },
  }
  HolidayColumns.push(HolidayIconRender)

  const handleAddClose = () => setAddOpen(false)
  const handleEditClose = () => setEditOpen(false)

  const handleSubmit = async () => {
    await dispatch(DeleteHolidayDataSettings({ payload: { id: paramsInfo?.id } }))
    openSnackBar()
    await dispatch(getHolidayData())
  }

  return (
    <div className={classes.container}>
      {delete_holiday_success && openSuccessSnackBar && <SuccessSnackBar message="Successfully deleted the holiday" />}
      {delete_holiday_error && openSuccessSnackBar && <ErrorSnackBar message="Unable to remove the holiday" />}
      {infoPassed && addHoliday && <AddHolidayDialog open={addOpen} handleClose={handleAddClose} />}
      {infoPassed && editHoliday && (
        <EditHolidayDialog open={editOpen} handleClose={handleEditClose} params={paramsInfo} />
      )}
      <Button
        className={classes.btn}
        onClick={() => handleAddHolidays({ holiday_date: '', holiday_day: '' })}
        sx={{ width: '200px', float: 'right', marginTop: '-65px' }}
        startIcon={<AddIcon />}
      >
        Add Holiday
      </Button>
      <Box
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#0d688d73',
            fontWeight: '600',
          },
          '& .MuiDataGrid-columnHeader--moving': {
            backgroundColor: 'transparent !important',
          },
          '& .MuiDataGrid-cell:hover': {
            cursor: 'pointer !important',
          },
          '& .MuiDataGrid-filterForm': { p: 2 },
        }}
      >
        {holidayData && (
          <DataGrid
            disableColumnSelector
            autoHeight
            pagination
            pageSize={10}
            rowsPerPageOptions={[10]}
            rows={holidayData.data}
            columns={HolidayColumns}
            loading={holidayData?.fetchInProgress}
          />
        )}
      </Box>
      {deleteHolidayOpen && (
        <DeleteDialog
          open={deleteHolidayOpen}
          onClose={handleDeleteHolidayClose}
          header={'Delete Holiday'}
          handleSubmit={handleSubmit}
        />
      )}
    </div>
  )
}
